import axios from './axios';

export const getHeader = () => {
    const header = {
        headers: {
            Auth: 'Basic Auth',
            Accept: "application/json",
            'X-MOBISTORM-API-KEY': 'bW9iaXN0b3JtOm1vYmlzdG9ybUAxMjM=',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
        }
    }
    return header;
}

export const getAuthHeader = () => {
    const token = 'Bearer ' + localStorage.getItem('userToken');
    const header = {
        headers: {
            Authorization: token,
            Accept: 'application/json',
            'X-MOBISTORM-API-KEY': 'bW9iaXN0b3JtOm1vYmlzdG9ybUAxMjM=',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            "Content-Type": "application/json"
        }
    }
    return header;
}


export const getAuthHeaderFD = () => {
    const token = 'Bearer ' + localStorage.getItem('userToken');
    const header = {
        headers: {
            Authorization: token,
            Accept: 'application/json',
            'X-MOBISTORM-API-KEY': 'bW9iaXN0b3JtOm1vYmlzdG9ybUAxMjM=',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            'Content-Type': 'multipart/form-data',
        }
    }
    return header;
}


export const sendOTP = async (postdata) => {
    return await axios.post('/send_otp', postdata, getHeader()).then(res => {
        return res;
    })
}
export const verifyOTP = async (postdata) => {
    return await axios.post('/verify_otp', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postLogin = async (postdata) => {
    return await axios.post('/login', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postRegiter = async (postdata) => {
    return await axios.post('/register', postdata, getHeader()).then(res => {
        return res;
    })
}


export const getHome = async () => {
    return await axios.get('/home', getAuthHeader()).then(res => {
        return res;
    })
}

export const getNewArrival = async () => {
    return await axios.get('/latest', getAuthHeader()).then(res => {
        return res;
    })
}

export const getCategory = async () => {
    return await axios.get('/master/category', getHeader()).then(res => {
        return res;
    })
}

export const get_common = async (data) => {
    return await axios.get('/master/get_common?page_slug=/' + data, getAuthHeader()).then(res => {
        return res;
    })
}

export const getPolicy = async (slug) => {
    return await axios.get(`/master/policy_details/${slug}`, getHeader()).then(res => {
        return res;
    })
}



//Product
export const postProductFilter = async (postdata) => {
    return await axios.post('product/filter', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postProduct = async (postdata) => {
    return await axios.post('/product', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postProductDetails = async (postdata) => {
    return await axios.post('/product/details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


// Cart
export const postCartWithoutLogin = async (postdata) => {
    return await axios.post('/cart/only', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postStoreCart = async (postdata) => {
    return await axios.post('/cart', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const getCartLogin = async () => {
    return await axios.get('/cart', getAuthHeader()).then(res => {
        return res;
    })
}

export const RemoveCart = async (id) => {
    return await axios.delete(`/cart/${id}`, getAuthHeader()).then(res => {
        return res;
    })
}


export const RemoveCartCombo = async (proids, groupKey) => {
    return await axios.delete(`/cart?bundle_product_id=${proids}&bundle_group_key=${groupKey}`, getAuthHeader()).then(res => {
        return res;
    })
}


//Wishlist
export const AddWishlist = async (postdata) => {
    return await axios.post('/wishlist', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const ListWishlist = async () => {
    return await axios.get('/wishlist', getAuthHeader()).then(res => {
        return res;
    })
}

export const RemoveWishlist = async (id) => {
    return await axios.delete(`/wishlist/${id}`, getAuthHeader()).then(res => {
        return res;
    })
}


//Manage Address
export const postPincode = async (postdata) => {
    return await axios.post('/master/pincode', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postAddAddress = async (postdata) => {
    return await axios.post('/user/address', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const getAddressList = async () => {
    return await axios.get('/user/address', getAuthHeader()).then(res => {
        return res;
    })
}

export const RemoveAddress = async (id) => {
    return await axios.delete(`/user/address/delete/${id}`, getAuthHeader()).then(res => {
        return res;
    })
}

export const setDefaultAddress = async (id) => {
    return await axios.get(`user/address/set_default/${id}`, getAuthHeader()).then(res => {
        return res;
    })
}


//Profile
export const getProfile = async () => {
    return await axios.get('/user/profile', getAuthHeader()).then(res => {
        return res;
    })
}

export const postProfile = async (postdata) => {
    return await axios.post('/user/profile', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postSendOtp = async (postdata) => {
    return await axios.post('/user/profile/send_otp', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


//Checkout
export const postCheckout = async (postdata) => {
    return await axios.post('/checkout', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postPaymentInit = async (postdata) => {
    return await axios.post('/checkout/payment_init', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postPaymentVerify = async (postdata) => {
    return await axios.post('/checkout/payment_verify', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const getCoupon = async () => {
    return await axios.get('/checkout/coupons', getAuthHeader()).then(res => {
        return res;
    })
}


//Order
export const getFilterList = async () => {
    return await axios.get('/order/filter_list', getAuthHeader()).then(res => {
        return res;
    })
}

export const postOrder = async (postdata) => {
    return await axios.post('/order', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postOrderDetail = async (postdata) => {
    return await axios.post('/order/details', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postWarrantyRedeemSubmit = async (postdata) => {
    return await axios.post('/warranty-redeem/submit', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}

export const postReview = async (postdata) => {
    return await axios.post('/order/review', postdata, getAuthHeaderFD()).then(res => {
        return res;
    })
}

export const postTracking = async (postdata) => {
    return await axios.post('/order/tracking', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const newsLaters = async (postdata) => {
    return await axios.post('/home/subscribe', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postSubCategory = async (postdata) => {
    return await axios.post('/master/sub_category', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postProductBrandModel = async (postdata) => {
    return await axios.post('/product/product_brand_model', postdata, getHeader()).then(res => {
        return res;
    })
}

export const categoryWiseProduct = async (postdata) => {
    return await axios.post('/product/category_wise_product', postdata, getHeader()).then(res => {
        return res;
    })
}

export const categoryWiseProductwithFilter = async (postdata) => {
    return await axios.post('/product/category_wise_product_with_filter', postdata, getHeader()).then(res => {
        return res;
    })
}







export const postComboList = async (postdata) => {
    return await axios.post('/product/combo_list', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postComboDetail = async (postdata) => {
    return await axios.post('/product/combo_details', postdata, getHeader()).then(res => {
        return res;
    })
}